// TODO: https://lawnstarter.atlassian.net/browse/PE-24883 to allow i18n

// eslint-disable-next-line import/prefer-default-export
export const ScheduleServiceItemIconStatusConstants = {
  pending: {
    icon: {
      name: 'calendar',
      color: 'primary',
    },
    status: {
      text: 'Upcoming service',
      appendOnMultiDate: ' between',
      startDatePath: 'next_starts_at',
      endDatePath: 'next_ends_at',
    },
  },

  active: {
    icon: {
      name: 'calendar',
      color: 'primary',
    },
    status: {
      text: 'Upcoming service',
      appendOnMultiDate: ' between',
      startDatePath: 'next_starts_at',
      endDatePath: 'next_ends_at',
    },
  },

  overdue: {
    icon: {
      name: 'calendar',
      color: 'danger',
    },
    status: {
      text: 'Upcoming service',
      appendOnMultiDate: ' between',
      startDatePath: 'next_starts_at',
      endDatePath: 'next_ends_at',
    },
  },

  cancelled: {
    icon: {
      name: 'cancel',
      color: 'danger',
    },
    status: {
      text: 'Cancelled on',
      endDatePath: 'status_set_at',
    },
  },

  ended: {
    icon: {
      name: 'close',
      color: 'tertiary',
    },
    status: {
      text: 'Ended on',
      endDatePath: 'status_set_at',
    },
  },

  // Quote Specific
  new: {
    icon: {
      name: 'calendar',
      color: 'primary',
    },
    status: {
      text: 'Scheduled',
      appendOnMultiDate: ' between',
      startDatePath: 'next_starts_at',
      endDatePath: 'next_ends_at',
    },
  },

  ready: {
    icon: {
      name: 'calendar',
      color: 'primary',
    },
    status: {
      text: 'Scheduled',
      appendOnMultiDate: ' between',
      startDatePath: 'next_starts_at',
      endDatePath: 'next_ends_at',
    },
  },

  priced: {
    icon: {
      name: 'calendar',
      color: 'tertiary',
    },
    status: {
      text: 'Review and approve your quote by',
      endDatePath: 'manualquote.expires_at',
    },
  },

  rejected: {
    icon: {
      name: 'cancel',
      color: 'danger',
    },
    status: {
      text: 'You rejected the quote on',
      endDatePath: 'manualquote.updated_at',
    },
  },

  expired: {
    icon: {
      name: 'cancel',
      color: 'danger',
    },
    status: {
      text: 'Your quote expired on',
      endDatePath: 'manualquote.updated_at',
    },
  },

  authorized: {
    icon: {
      name: 'checkmark',
      color: 'primary',
    },
    status: {
      text: 'You approved the quote on',
      endDatePath: 'manualquote.updated_at',
    },
  },

  fallback: {
    icon: {
      name: 'calendar',
      color: 'primary',
    },
    status: {
      text: 'n/a',
    },
  },
};

export const ScheduleServiceItemIconStatusPartnersConstants = {
  AWAITING_SCHEDULE: {
    icon: {
      name: 'calendar',
      color: 'primary',
    },
    status: {
      text: 'Upcoming service',
      appendOnMultiDate: ' between',
      startDatePath: 'ltrsWindowStart',
      endDatePath: 'ltrsWindowEnd',
    },
  },
  SCHEDULED: {
    icon: {
      name: 'calendar',
      color: 'primary',
    },
    status: {
      text: 'Upcoming service:',
      startDatePath: 'ltrsWindowStart',
      endDatePath: 'ltrsWindowEnd',
    },
  },
};
